import { useAttributeGroupSelect } from "@/modules/dynamic-attributes/feature/attribute-select/select-attribute-group";
import { useQuery } from "@apollo/client";
import { DynamicAttributeEntity, GetEntityAttributesQuery } from "gql/graphql";
import { createContext, ReactNode, useContext } from "react";
import { useParams } from "react-router-dom";
import { GET_ENTITY_ATTRIBUTES } from "../../../dynamic-attribute-editor/api/get-entity-attributes";

type Groups =
  GetEntityAttributesQuery["getDynamicAttributeGroupMetaInfo"]["groups"];

type Group = Groups[number];

type ContextProps = {
  data: GetEntityAttributesQuery | undefined;
  loading: boolean;
  groups: Groups;
  group: Group;
};

const Context = createContext<ContextProps>({} as ContextProps);

export function EntityAttributesGroupContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { entity } = useParams<{ entity: string }>();
  const { attributeGroup } = useAttributeGroupSelect();

  const { data, loading } = useQuery(GET_ENTITY_ATTRIBUTES, {
    variables: {
      entity: entity as DynamicAttributeEntity,
    },
    fetchPolicy: "network-only",
  });

  const groups = data?.getDynamicAttributeGroupMetaInfo.groups ?? [];
  const group =
    groups.find((group) => group.id === attributeGroup) ?? ({} as Group);

  return (
    <Context.Provider value={{ data, groups, loading, group }}>
      {children}
    </Context.Provider>
  );
}

export function useGroupsData() {
  return useContext(Context);
}
